import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Navbar from './components/misc/Navbar'
import Home from './components/home/Home'
import Register from './components/auth/Register'
import Login from './components/auth/Login'

function Router() {
    return (
        <BrowserRouter>
            <Navbar />
            <Switch>
                <Route path='/login' component={Login}></Route>
                <Route path='/register' component={Register}></Route>
                <Route exact path='/' component={Home}/>
            </Switch>
        </BrowserRouter>
    )
}

export default Router
